export default function HeatmapCalendar() {
  return (
    <div className="glass-card p-8 rounded-3xl">
      <h2 className="text-2xl font-bold text-black">
        📅 Study Activity
      </h2>
    </div>
  );
}